// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".register-account-warp .item-checked .el-checkbox__input {\n  margin-top: 4px !important;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
